export default class CommentItem
{
	constructor(item) 
	{
		if(item!==undefined)
		{
			this.CommentId = item.CommentId;
			this.CreatedOn = item.createdOn;
			this.Message = item.message;
			this.Type = item.type;
			this.CreatedByName = item.createdByName;
		}
		
	}
}
